// Required by AWS Cognitos
(window as any).global = window
